<template>
  <b-form-group
    label="Search Zone"
  >
    <v-select
      ref="selectRef"
      label="name"
      :options="zones"
      :loading="loadingZones"
      @input="onZoneSelected"
    />
  </b-form-group>
</template>

<script>
import {
  BFormGroup,
} from 'bootstrap-vue'
import { computed, watch } from '@vue/composition-api'
import vSelect from 'vue-select'
import useZoneList from '@/views/zones/useZoneList'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import zonesStore from '@/views/zones/zoneStoreModule'

export default {
  components: {
    BFormGroup,
    vSelect,
  },
  setup(_, ctx) {
    useRegisterStoreModule('zones', zonesStore)
    const { tableData: fetchedZones, loadingZones, ...rest } = useZoneList()
    const zones = computed(() => {
      let temp = []
      temp = fetchedZones.value?.filter(el => el.area === 'None')
      return temp
    })

    const onZoneSelected = event => {
      if (!event) {
        ctx.emit('zone-selected', null)
        return
      }

      ctx.emit('zone-selected', `${event.country}::${event.city}`)
    }
    watch(loadingZones, () => {
      ctx.emit('zones-loading-state', loadingZones.value)
    }, { immediate: true })

    const resetValue = () => {
      ctx.refs.selectRef.clearSelection()
    }
    return {
      loadingZones,
      resetValue,
      ...rest,
      zones,
      onZoneSelected,
    }
  },
}
</script>
